import { useEffect } from 'react';
export function useKeybind({ key, onKeyPress, enabled = true }) {
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const handleKeyDown = (event) => {
            const keys = Array.isArray(key) ? key : [key];
            if (keys.includes(event.key)) {
                event.preventDefault();
                onKeyPress();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [key, onKeyPress, enabled]);
}
